import styles from './PropertySpyHome.module.css'
import { PropertySpyNotAdded } from './presentationals/PropertySpyNotAdded'
import { PropertySpyCard } from './presentationals/PropertySpyCard'
import { useState } from 'react'
import { PropertySpyStopConfirmationDialog } from 'shared/widgets/PropertySpyStopConfirmationDialog'
import { useReadPropertySpyListQuery, useStopSpyHostServiceMutation } from 'entities/propertySpy/api/propertySpyApi'
import { DefaultContextControl } from 'shared/widgets/DefaultContextControl'
import { useAppSelector } from 'shared/hooks'
import { selectContextLocationSearchString } from 'store/applicationSlice'
import { useContextSpyLaunchSettings } from 'shared/hooks/useContextSpyLaunchSettings1'
import { useContextFilters } from 'shared/hooks/useContextFilters'
import { useContextLocation } from 'shared/hooks/useContextLocation'
import { ReadPropertySpyListParamsModel } from 'entities/propertySpy/api/types'
import { DefaultContextControlContainer } from 'shared/containers/DefaultContextControl/DefaultContextControlContainer'
import { useEventListener } from 'shared/providers/EventBusProvider'

export const PropertySpyHome = (): JSX.Element => {
    const locationString: any = useAppSelector(selectContextLocationSearchString)
    const {
        selectContextLocation,
    } = useContextLocation()

    const {
        selectContextFilters
    } = useContextFilters()

    const getReadPropertySpyListQueryParams = (): any => {
        const params = {
            ...(selectContextLocation !== undefined) && {locationsIds: [selectContextLocation.id]},
            // ...(contextFilters?.bedrooms !== undefined) && {bedrooms: contextFilters?.bedrooms},
            // ...(contextFilters?.beds !== undefined) && {beds: contextFilters?.beds},
            // ...(contextFilters?.pets !== undefined) && {pets: contextFilters?.pets}     
        }

        if (Object.keys(params).length === 0 ){
            return undefined
        }

        return params
    }

    const [readPropertySpyListQueryParams, setReadPropertySpyListQueryParams] = useState<ReadPropertySpyListParamsModel | undefined>(getReadPropertySpyListQueryParams())
    const {
        data: readPropertySpyListData,
        isLoading: readPropertySpyListIsLoading,
        isFetching: readPropertySpyListIsFetching
    } = useReadPropertySpyListQuery(readPropertySpyListQueryParams)
    //

    const [stopSpyInformation, setStopSpyInformation] = useState<any>(undefined)
    const [propertySpyStopConfirmationDialogOpen, setPropertySpyStopConfirmationDialogOpen] = useState<boolean>(false)
    const [stopSpyHostService] = useStopSpyHostServiceMutation()

    const handleDeletePropertySpy = async (event: any) => {
        setStopSpyInformation(event)
        setPropertySpyStopConfirmationDialogOpen(true)
    }

    const handlePropertySpyStopConfirmationDialogCancel = (event: any) => {
        setStopSpyInformation(undefined)
        setPropertySpyStopConfirmationDialogOpen(false)
    }

    const handlePropertySpyStopConfirmationDialogOk = async (event: any) => {
        await stopSpyHostService({
            hostServiceId: stopSpyInformation.hostServiceId,
            marketSpyId: stopSpyInformation.spyId
        }) 

        setStopSpyInformation(undefined)
        setPropertySpyStopConfirmationDialogOpen(false)
    }

    
    const handleDefaultContextContainerSearch = (event: any) => {
        setReadPropertySpyListQueryParams(getReadPropertySpyListQueryParams())
    }

    useEventListener('defaultContextControl:search', (item) => {
        setReadPropertySpyListQueryParams(getReadPropertySpyListQueryParams())
    }, [
        setReadPropertySpyListQueryParams,
        getReadPropertySpyListQueryParams
    ])

    let content = null

    if (readPropertySpyListIsLoading) {
        content = (
            <div className={styles.PropertySpyHome__LoadingContainer}>
                <h2>Loading</h2>
            </div>
        )
    }

    if (readPropertySpyListData?.count === 0) {
        content = (
            <div className={styles.PropertySpyHome__PropertySpyNotAddedContainer}>
                <PropertySpyNotAdded />
            </div>
        )
    }

    if (readPropertySpyListData?.count > 0) {
        content = (
            <div className={styles.PropertySpyHome__PropertySpyListCardContainer}>
                {
                    readPropertySpyListData?.list
                        .map((propertySpy: any) => {
                            return (     
                                <div key={propertySpy.id}
                                    className={styles.PropertySpyHome__PropertySpyCardContainer}>
                                    <PropertySpyCard
                                        propertySpy={propertySpy}                                 
                                        onDelete={handleDeletePropertySpy}
                                    />
                                </div>                           
                            )
                        })
                }   
            </div>
        )
    }

    return (
        <div className={styles.PropertySpyHome__Root}>
            {content}  
            <PropertySpyStopConfirmationDialog 
                open={propertySpyStopConfirmationDialogOpen}
                keepMounted={false}
                onCancel={handlePropertySpyStopConfirmationDialogCancel}
                onOk={handlePropertySpyStopConfirmationDialogOk}      
            />
            <DefaultContextControlContainer />
        </div>
    )
}